import React from 'react';

const PlusIconDark: React.FC = () => (
    <svg
    width="15"
    height="12"
    viewBox="0 0 15 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
>
    <path
        d="M0.9375 7.68346C1.17912 7.68346 1.375 7.87672 1.375 8.11512V10.2734C1.375 10.7502 1.76675 11.1367 2.25 11.1367H12.75C13.2332 11.1367 13.625 10.7502 13.625 10.2734V8.11512C13.625 7.87672 13.8209 7.68346 14.0625 7.68346C14.3041 7.68346 14.5 7.87672 14.5 8.11512V10.2734C14.5 11.227 13.7165 12 12.75 12H2.25C1.2835 12 0.5 11.227 0.5 10.2734V8.11512C0.5 7.87672 0.695875 7.68346 0.9375 7.68346Z"
        fill="#343A40"
    />
    <path
        d="M7.19064 9.36996C7.3615 9.53853 7.63851 9.53853 7.80936 9.36996L10.4344 6.78003C10.6052 6.61146 10.6052 6.33815 10.4344 6.16958C10.2635 6.00101 9.9865 6.00101 9.81564 6.16958L7.9375 8.02263V0.431654C7.9375 0.193258 7.74162 0 7.5 0C7.25838 0 7.0625 0.193258 7.0625 0.431654V8.02263L5.18436 6.16958C5.0135 6.00101 4.7365 6.00101 4.56564 6.16958C4.39479 6.33815 4.39479 6.61146 4.56564 6.78003L7.19064 9.36996Z"
        fill="#343A40"
    />
</svg>
);

export default PlusIconDark;
